export default "__VITE_ASSET__Ds5lPneF__"